import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { preloadCreateSpace } from '@confluence/create-space-preload/entry-points/preloadCreateSpace.ts';

import {
	StarredSpacesQuery,
	MyVisitedSpacesQuery,
	MyVisitedSpacesWithCurrentSpaceQuery,
	AnonymousSpacesQuery,
} from './SpacesListQueries.graphql.ts';

type preloadSpacesListOptions = {
	isLicensed: boolean;
	selectedSpaceKey?: string;
};

export const preloadSpacesList = ({ isLicensed, selectedSpaceKey }: preloadSpacesListOptions) => {
	const preloadQueries = [];

	if (isLicensed) {
		preloadQueries.push(
			query({
				/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
				query: StarredSpacesQuery,
				variables: {},
			}),
		);
		if (selectedSpaceKey) {
			preloadQueries.push(
				query({
					/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
					query: MyVisitedSpacesWithCurrentSpaceQuery,
					variables: { selectedSpaceKey },
				}),
			);
		} else {
			preloadQueries.push(
				query({
					/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
					query: MyVisitedSpacesQuery,
					variables: {},
				}),
			);
		}
	} else {
		preloadQueries.push(
			query({
				/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
				query: AnonymousSpacesQuery,
				variables: {},
			}),
		);
	}

	preloadQueries.push(preloadCreateSpace({ isLicensed }));

	return waitForAllReturnWhenError(preloadQueries);
};
